/* ============================================
   BF COUNTDOWN BFE - Acelera
   Drijft alle [data-bf-countdown]-klokken op de pagina (snippet bf-countdown-bfe).
   Vóór de start: aftellen naar de start. Tijdens de actie: naar het einde.
   Na afloop: klok (en optioneel data-hide-target) verbergen.
   Versie: 1.0.0 - 14-10-2026
   ============================================ */
(function() {
  if (window.__bfCountdownBfe) return;
  window.__bfCountdownBfe = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function setup(el) {
    if (el.__bfInit) return;
    el.__bfInit = true;
    var start = parseInt(el.getAttribute('data-start'), 10) * 1000;
    var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
    if (isNaN(end)) return;
    var stateEl = el.querySelector('[data-bf-cd-state]');
    var nums = {
      d: el.querySelector('[data-bf-cd-d]'), h: el.querySelector('[data-bf-cd-h]'),
      m: el.querySelector('[data-bf-cd-m]'), s: el.querySelector('[data-bf-cd-s]')
    };
    var t = { starts: el.getAttribute('data-t-starts'), live: el.getAttribute('data-t-live'), ends: el.getAttribute('data-t-ends') };
    var hideSel = el.getAttribute('data-hide-target');
    var last = '';

    function tick() {
      var now = Date.now();
      if (now >= end) {
        el.hidden = true;
        var target = hideSel && el.closest(hideSel);
        if (target) target.hidden = true;
        return false;
      }
      var before = !isNaN(start) && now < start;
      var state = before ? 'before' : 'live';
      if (stateEl && state !== last) {
        stateEl.textContent = '';
        if (before) {
          stateEl.textContent = t.starts;
        } else {
          var b = document.createElement('b');
          b.textContent = t.live;
          stateEl.appendChild(b);
          stateEl.appendChild(document.createTextNode(' · ' + t.ends));
        }
      }
      last = state;
      var ms = Math.max(0, (before ? start : end) - now);
      nums.d.textContent = pad(Math.floor(ms / 864e5));
      nums.h.textContent = pad(Math.floor(ms / 36e5) % 24);
      nums.m.textContent = pad(Math.floor(ms / 6e4) % 60);
      nums.s.textContent = pad(Math.floor(ms / 1e3) % 60);
      el.hidden = false;
      return true;
    }

    if (tick()) {
      var timer = setInterval(function() { if (!tick()) clearInterval(timer); }, 1000);
    }
  }

  function init() { document.querySelectorAll('[data-bf-countdown]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme-editor: secties worden opnieuw geladen
  document.addEventListener('shopify:section:load', init);
})();
